import { render, staticRenderFns } from "./BrandInputCore.vue?vue&type=template&id=743f2be9&"
import script from "./BrandInputCore.vue?vue&type=script&lang=js&"
export * from "./BrandInputCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports